export class TableHeaders{ 
    readonly columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    readonly rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    readonly columnHeaders384 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
    readonly rowHeaders384 = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];
}